import React from "react";
import Layout from "./layouts/layout";
import NoticiaCard from "./blocks/noticiaCard";
import Subheader from "./blocks/subheader";
import es from "../i18n/es";
import en from "../i18n/en";
import Footer from "./blocks/footer";

const MAX_NEWS = 10;

let isValid = function (obj) {
  return obj && obj.Image &&
      obj.Title && !Array.isArray(obj.Title) && typeof obj.Title === 'object' &&
      obj.Description && !Array.isArray(obj.Description) && typeof obj.Description === 'object';
}

function Noticias(props) {
  let textos = es;
  if (props.lang === 'en') { textos = en; }
  let noticias = null;
  if (props.data && props.data.News) {
    noticias = props.data.News;
  }
  const textColor = props.data.Config.Primary_color || 'black';
  if (noticias) {
/*
    noticias.push({
      Id: 1000,
      Image: "uploads/images/Noticias/2e1d43b48727626cb4904c4d80677cee.png",
      Title: {es: 'titulo dsalkdnaslk ndsalkdnasl ndalsm dasl,md lasmdlsm ldmsa', en: "Title"},
      Description: {es: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', en: "Description"}
    });
*/
    noticias = noticias.filter((obj) => isValid(obj));
    noticias = noticias.slice(0, MAX_NEWS);
  }
  return (
      <Layout data={props.data} withMarginTop={true} lang={props.lang}>
        {
          noticias &&
          <div className="text-center mainViewContent">

            <Subheader text={textos.News} bgColor={props.data.Config.Secondary_color} />

            {
              noticias.length === 0 &&
              <div style={{color:textColor}}>{textos.NoNews}</div>
            }

            {
              noticias.map((noticia, index) =>
                <NoticiaCard key={index}
                             mainColor={props.data.Config.Primary_color}
                             data={noticia}
                             lang={props.lang} />
              )
            }
          </div>
        }

        <Footer data={props.data} />

      </Layout>
  );
}

export default Noticias;
